<template>
  <div class="supervision-wrap">
    <div class="nav-wrap">
      <div class="flex">
        <i class="iconfont icon-home1"></i>
        <router-link class="link" to="/">首页</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" to="/server/main">信用服务</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" :to="$route.path" replace
          ><span>信用评价</span></router-link
        >
      </div>
    </div>
    <div class="supervision-box">
      <div class="inner">
        <div class="inner-top-title">请选择已经认领的企业</div>
        <div style="display: flex; flex-direction: row; align-items: center">
          <el-select
            placeholder="请选择企业名称"
            v-model="number"
            @change="selectChange"
          >
            <el-option
              v-for="item in companyList"
              :key="item.number"
              :label="item.name"
              :value="item.number"
            ></el-option>
          </el-select>
          <!-- 自主申报 -->
          <div
            class="declare"
            v-if="companyList.length != 0"
            @click="isDialogTableVisibleChange"
          >
            自主申报
          </div>
          <router-link
            to="/user/historical-declaration"
            style="color: #0090ff; margin-left: 20px"
            >历史申报</router-link
          >
        </div>
        <div class="canvas-box">
          <canvas id="canvasId" width="250" height="250" />
        </div>
        <div class="score-box flex">
          <div class="score-inner">
            <div class="score-number">{{ score.score || 0 }}</div>
            <div class="score-text">当前分值</div>
          </div>
          <div class="score-inner">
            <div class="score-number">{{ score.basicScore || 0 }}</div>
            <div class="score-text">基本分值</div>
          </div>
        </div>
      </div>
      <div class="inner">
        <div class="inner-bottom-title flex">
          <img src="@/static/images/dynamics/14.png" alt="" />
          <span>分值记录</span>
        </div>
        <el-table :data="list" :header-row-style="headerClass">
          <el-table-column
            label="内容"
            prop="indexName"
            width="700px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="时间"
            prop="scoreTime"
            align="center"
          ></el-table-column>
          <el-table-column label="分值" prop="score" align="center">
            <template slot-scope="{ row }">
              <span :style="{ color: row.score >= 0 ? '#D01C0B' : '' }">{{
                row.score
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex flex-row-end page-wrap" v-if="list.length > 0">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :pageSize="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="companyList.length != 0"
      title="自主申报"
      :visible.sync="isDialogTableVisible"
      width="35%"
    >
      <el-form
        :model="declareForm"
        label-width="80px"
        :rules="rulesObj"
        label-position="left"
        ref="formName"
      >
        <el-form-item label="企业名称" prop="enterpriseName">
          <el-input
            type="text"
            size="small"
            v-model="declareForm.enterpriseName"
            clearable
            disabled
            placeholder="请填写企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="creditNumber">
          <el-input
            class="d-input"
            maxlength="18"
            type="text"
            size="small"
            disabled
            v-model="declareForm.creditNumber"
            clearable
            placeholder="请填写统一社会信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="奖章等级" prop="region">
          <el-select
            style="width: 100% !important"
            v-model="declareForm.region"
            placeholder="请选择奖章等级"
          >
            <el-option
              :label="item"
              :value="i"
              v-for="(item, i) in gradeArr"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖励日期" prop="startDate">
          <el-date-picker
            v-model="declareForm.startDate"
            type="date"
            placeholder="奖励日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="过期日期" prop="endDate">
          <el-date-picker
            v-model="declareForm.endDate"
            type="date"
            placeholder="过期日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="文书号" prop="docNumber">
          <el-input
            type="text"
            size="small"
            v-model="declareForm.docNumber"
            clearable
            placeholder="请填写文书号"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="上传奖章">
          <el-upload
            :action="action"
            accept=".pdf,.jpg,.png"
            :show-file-list="true"
            :before-upload="handleUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            :limit="1"
          >
            <el-button type="primary">上传奖章文件</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传对应的PDF或图片文件(jpg格式、png格式)
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isDialogTableVisible = false">取消申报</el-button>
        <el-button type="primary" @click="submitDeclare">提交申报</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  creditMemberEnterpriseClaims,
  scoreList,
  score,
  setDeclareInfo,
} from "@/api";
export default {
  components: {},
  data() {
    return {
      action: "/api/file/upload",
      companyList: [],
      number: undefined,
      enterpriseName: "",
      score: {},
      list: [],
      percent: 0,
      pageSize: 10,
      total: 0,
      // 自主申报弹窗
      isDialogTableVisible: false,
      gradeArr: [
        "单位获得县级以上表彰或奖励",
        "单位获得市级以上表彰或奖励",
        "单位获得省级以上表彰或奖励",
        "单位主要负责人获得市（厅）级以上表彰或奖励",
        "企业获得市级工程质量安全奖项",
        "企业获得省级工程质量安全奖项",
        "企业获得国家级工程质量安全奖项",
        "企业获评泰安市级科技研发平台",
        "企业获评泰安省级科技研发平台",
        "企业获评泰安国家级科技研发平台",
        "企业获评泰安市级科技人才工程",
        "企业获评泰安省级科技人才工程",
        "企业获评泰安国家级科技人才工程",
      ],
      declareForm: {
        region: "", // 奖章等级
        startDate: "", // 奖励日期
        endDate: "", // 过期日期
        docNumber: "", // 文书号
        creditNumber: "", // 社会信用代码
        enterpriseName: "", // 企业名称
        file_url: null,
      },

      // 校验
      rulesObj: {
        enterpriseName: [
          { required: true, message: "请填写企业名称", trigger: "blur" },
        ],
        creditNumber: [
          { required: true, message: "请填写社会信用代码", trigger: "change" },
          {
            min: 18,
            message: "请检查社会信用代码",
            trigger: "change",
          },
        ],
        startDate: [
          {
            type: "date",
            required: true,
            message: "请填写开始日期",
            trigger: "change",
          },
        ],
        endDate: [
          {
            type: "date",
            required: true,
            message: "请填写过期日期",
            trigger: "change",
          },
        ],
        region: [
          {
            required: true,
            message: "一定要选择奖章等级",
            trigger: "change",
          },
        ],
        docNumber: [
          { required: true, message: "请填写书文号", trigger: "change" },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      let companyList = await creditMemberEnterpriseClaims();
      this.$set(this, "companyList", companyList || []);
      const [first = {}] = companyList || [];
      const { number, name, id } = first;
      this.$set(this, "number", number);
      this.$set(this, "enterpriseName", name);
      this.$set(this.declareForm, "id", id);

      this.queryScore(number);
    },

    // 点击弹出自主申报填写
    isDialogTableVisibleChange() {
      this.declareForm.enterpriseName = this.enterpriseName;
      this.declareForm.creditNumber = this.number;
      this.isDialogTableVisible = true;
    },

    // 文件上传前
    handleUpload(file) {
      const { type } = file;
      if (!["application/pdf", "image/jpeg", "image/png"].includes(type)) {
        this.$message({
          message: "只能上传jpg、png和pdf格式文件",
          type: "warning",
        });
        return false;
      }
      return true;
    },

    // 文件上传成功
    handleSuccess(res, file) {
      this.declareForm.file_url = JSON.stringify([
        {
          name: file.name,
          fileId: file.response.result.slice(
            file.response.result.lastIndexOf("/") + 1
          ),
          url: file.response.result,
        },
      ]);
      this.$message({
        message: "文件上传完毕",
        type: "success",
      });
    },

    // 上传失败
    handleError(err) {
      this.$message.error("文件上传失败！");
    },
    // 清空数据
    reset() {
      this.$message({
        message: "申报提交成功",
        type: "success",
      });
      this.isDialogTableVisible = false;
      this.declareForm = {
        creditNumber: "", // 社会信用代码
        enterpriseName: "", // 企业名称
        region: "", // 奖章等级
        startDate: "", // 奖励日期
        endDate: "", // 过期日期
        docNumber: "", // 文书号
        file_url: null, // 文件路径
      };
    },

    // 提交申报
    submitDeclare() {
      this.$refs.formName.validate((valid) => {
        if (valid) {
          setDeclareInfo({
            jljb: this.declareForm.region, // 奖励级别
            jlsyrq: Date.parse(this.declareForm.startDate), // 奖励授予日期
            yxjzq: Date.parse(this.declareForm.endDate), // 有效截止期
            rdwsh: this.declareForm.docNumber, // 认定文书号
            fileUrl: this.declareForm.file_url, // 文件
            xzxdrdm: this.declareForm.creditNumber, // 社会信用代码
            xzxdrmc: this.declareForm.enterpriseName, // 企业名称
            id: this.declareForm.id, // 企业名称
          }).then((val) => {
            this.reset();
          });
        } else {
          console.log("error submit!!");
        }
      });
    },

    queryScore(number) {
      score({ enterpriseCode: number })
        .then((res) => {
          this.$set(this, "score", res || {});
          if (Object.keys(res).length) {
            const { score = 0, basicScore = 0 } = res || {};
            this.$set(
              this,
              "percent",
              ((score / basicScore) * 100).toFixed(0)
            ) || 0;
          }
        })
        .finally(() => {
          const canvas = document.getElementById("canvasId");
          this.drawMain(canvas, this.percent, this.score.scoreLevel);
        });
      this.queryList(number);
    },

    queryList(number, page = 1) {
      scoreList({ enterpriseCode: number, current: page }).then((res) => {
        const { records = [], size, total } = res;
        this.$set(this, "pageSize", size);
        this.$set(this, "total", total);
        this.$set(this, "list", records);
      });
    },

    selectChange(e) {
      this.$set(this, "number", e);
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].number == e) {
          this.$set(this, "enterpriseName", this.companyList[i].name);
          this.$set(this.declareForm, "id", this.companyList[i].id);
          break;
        }
      }
      this.queryScore(e);
    },

    handleCurrentChange(e) {
      this.queryList(this.number, e);
    },

    headerClass() {
      return "background: #f4f4f4 !important;";
    },

    drawMain(drawing_elem, percent, text) {
      /*
				@drawing_elem: 绘制对象
				@percent：绘制圆环百分比, 范围[0, 100]
				@forecolor: 绘制圆环的前景色，颜色代码
				@bgcolor: 绘制圆环的背景色，颜色代码
				@colornums: 作为参数传入，绘制哪个颜色
			*/
      var context = drawing_elem.getContext("2d");
      var center_x = drawing_elem.width / 2;
      var center_y = drawing_elem.height / 2;
      var rad = (Math.PI * 2) / 100;
      var speed = 0;

      // 绘制背景圆圈
      function backgroundCircle() {
        context.save();
        context.beginPath();
        context.lineWidth = 22; // 设置线宽
        var radius = center_x - context.lineWidth;
        context.lineCap = "round";
        context.strokeStyle = "#E5E5E5";
        context.arc(center_x, center_y, radius, 0, Math.PI * 2, false);
        context.stroke();
        context.closePath();
        context.restore();
      }

      // 绘制运动圆环
      function foregroundCircle(n) {
        context.save();
        // context.strokeStyle = forecolor //决定圆环颜色
        context.lineWidth = 22;
        context.lineCap = "round";
        var radius = center_x - context.lineWidth;
        context.beginPath();

        var g = context.createLinearGradient(0, 0, 180, 0);
        g.addColorStop(0, "#F67C39");
        g.addColorStop(1, "#F73E4F");
        context.strokeStyle = g;

        context.arc(
          center_x,
          center_y,
          radius,
          -Math.PI / 4,
          -Math.PI / 4 + n * rad,
          false
        ); // 用于绘制圆弧context.arc(x坐标，y坐标，半径，起始角度，终止角度，顺时针/逆时针)
        context.stroke();
        context.closePath();
        context.restore();
      }

      // 绘制文字
      function drawText(n) {
        context.save(); // save和restore可以保证样式属性只运用于该段canvas元素
        context.fillStyle = "#FF2F39";
        var font_size = 44;
        context.font = font_size + "px Helvetica";
        var text_width = context.measureText(text).width;
        context.fillText(
          text,
          center_x - text_width / 2,
          center_y + font_size / 2
        );
        context.restore();
      }

      // 执行动画
      (function drawFrame() {
        if (speed <= percent) {
          window.requestAnimationFrame(drawFrame);
        } else {
          return false;
        }
        context.clearRect(0, 0, drawing_elem.width, drawing_elem.height);
        backgroundCircle();
        text && drawText(speed);
        foregroundCircle(speed);
        if (speed >= percent) {
          speed++;
        } else {
          speed += 1;
        }
      })();
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.supervision-wrap {
  .supervision-box {
    width: 1280px;
    margin: 20px auto;

    .inner {
      border: 1px solid #e5e5e5;
      background-color: #fff;

      & + .inner {
        margin-top: 20px;
      }

      &:first-of-type {
        padding-top: 57px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 123px;
      }

      &:last-of-type {
        padding: 30px 54px;
      }

      .inner-top-title {
        color: #d11d0f;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
      }

      .declare {
        background-color: #d11d0f;
        height: 50px;
        padding: 0px 20px;
        margin-left: 10px;
        border-radius: 5px;
        color: #fff;
        line-height: 50px;
        letter-spacing: 1px;
        cursor: pointer;
      }

      .el-select {
        margin: 26px auto;
      }

      .score-box {
        margin-top: 86px;

        .score-inner {
          width: 295px;
          text-align: center;

          &:first-of-type {
            border-right: 1px solid #e5e5e5;
          }

          .score-number {
            font-size: 40px;
            color: #191a1a;
          }

          .score-text {
            color: #313131;
            font-size: 16px;
            margin-top: 30px;
          }
        }
      }

      .canvas-box {
        #canvasId {
          margin: 0 auto;
        }
      }

      .inner-bottom-title {
        img {
          width: 30px;
          height: 30px;
        }

        span {
          line-height: 30px;
          font-size: 18px;
          color: #313131;
        }
      }

      .el-table {
        margin-top: 16px;
      }

      .page-wrap {
        margin-top: 20px;

        .el-pagination {
          padding: 0;
        }
      }
    }
  }

  .header-background {
    background-color: #f4f4f4;

    th {
      background-color: #f4f4f4;
    }
  }
}

.el-input {
  width: 100% !important;
}

</style>
